import PropTypes from 'prop-types';
import { Button } from '@gogovan/entier-web-core/ext/mui/Button';
import { CircularProgress } from '@gogovan/entier-web-core/ext/mui/CircularProgress';

const LoadingButton = ({ isLoading, children, ...rest }) => {
  const disabled = rest?.disabled || isLoading;
  return (
    <Button {...rest} disabled={disabled}>
      {isLoading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : children}
    </Button>
  );
};

LoadingButton.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node,
};

export default LoadingButton;
